import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import "./StageGrid.css";
import { useNavigate } from "react-router-dom";

const StageGrid = ({ data = [] }) => {
    const navigate = useNavigate();

    let stageData = data?.flatMap(stage => stage?.child_stage_data || []);

    return (
        <Container fluid className="stage-grid-container">
            <Row className="g-4 align-items-stretch">
                {stageData?.map((item, index) => (
                    <Col key={index} xs={12} sm={6} md={3} className="mb-4 d-flex">
                        <Card
                            className="stage-card flex-fill"
                            onClick={() => navigate(`/analytics/${item?.application_stage_name}`)}
                        >
                            <Card.Body className="stage-card-body">
                                <Card.Title className="stage-card-title">
                                    {item?.application_stage_name}
                                </Card.Title>
                                <div className="stage-card-info">
                                    <span className="stage-card-count">{item?.no_of_application}</span>
                                    {item?.sum_loan_amount && (
                                        <span className="stage-card-amount">
                                            {
                                                (item?.application_stage_name === 'Loan Created' || item?.application_stage_name === 'eSign Completed' || item?.application_stage_name === 'eSign Requested') ?
                                                item?.sum_sanction_amount?.toLocaleString('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }) :
                                                item?.sum_loan_amount?.toLocaleString('en-IN', { style: 'currency', currency: 'INR',  minimumFractionDigits: 0, maximumFractionDigits: 0 })
                                            }
                                        </span>
                                    )}
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))}
            </Row>
        </Container>
    );
};

export default StageGrid;
